<div
  #editorContainer
  class="hx-text-editor"
  [attr.aria-disabled]="disabledState() || null"
  [attr.aria-invalid]="errorState"
  [attr.aria-readonly]="readonly()"
  [attr.aria-required]="requiredValue"
  [attr.id]="idValue"
  [class.hx-text-editor--in-container]="_isInContainer"
  [class.hx-text-editor-disabled]="disabledState()"
  [class.hx-text-editor-error]="errorState"
  [class.hx-text-editor-focused]="focused"
  [class.hx-text-editor-lg]="size() === 'lg'"
  [class.hx-text-editor-sm]="size() === 'sm'"
  [class.hx-text-editor-xl]="size() === 'xl'"></div>

<hx-icon-picker
  #iconPicker
  class="hx-text-editor-icon-picker"
  [categories]="iconCategories()"
  [dialogTitle]="'Insert Icon'"
  [showLabel]="false"
  [dialogSize]="'large'"
  [dialogMaxHeight]="'80vh'"
  (valueChange)="onIconSelected($event)"></hx-icon-picker>
